import React from 'react'
import { Link } from 'react-router-dom'

import LogoTipo from '../../images/logos/logotipo.png'

export interface LogoProps {
  className?: string
  searchEngine: boolean | undefined
}

const Logo: React.FC<LogoProps> = ({ className = 'w-50', searchEngine }) => {
  return (
    <Link
      to={searchEngine ? '/home' : '/'}
      className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
    >
      <img className={`block max-h-16`} src={LogoTipo} alt="Logo" />
    </Link>
  )
}

export default Logo
